<template>
  <div
    class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header m-0"
  >
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header truncated_header mb-4"
      >
        <div class="md-layout">
          <div
            class="md-layout-item md-medium-size-100 md-size-100 truncated_header2"
          >
            <div class="md-layout md-alignment-center">
              <div
                class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-60 p-0 report-header"
              >
                <h1 class="title-h4-formatting">
                  {{ this.headerData.title + ": " }}
                </h1>
                <ul>
                  <li>
                    <p class="sub-title-formatting">
                      <i class="md-icon md-icon-dark-blue">business_center</i
                      >Industry:
                    </p>
                    <p>
                      [{{ parseFloat(this.headerData.bznaics) }}]
                      {{ this.headerData.industry }}
                    </p>
                  </li>
                  <li>
                    <p class="sub-title-formatting">
                      <i class="md-icon md-icon-dark-blue">apartment</i>Sector:
                    </p>
                    <p>{{ this.headerData.sector }}</p>
                  </li>
                  <li>
                    <p class="sub-title-formatting">
                      <i class="md-icon md-icon-dark-blue">place</i>Market Area:
                    </p>
                    <p>{{ this.headerData.area }}</p>
                  </li>
                  <li>
                    <p class="sub-title-formatting">
                      <i class="md-icon md-icon-dark-blue">equalizer</i>Sales
                      Class:
                    </p>
                    <p>{{ this.headerData.sales_class }}</p>
                  </li>
                </ul>
              </div>
              <div
                class="md-layout-item md-medium-size-100 md-xsmall-size-50 md-size-40 button-box"
              >
                <md-button
                  class="md-info access-button pdf_btn"
                  @click="feedback"
                >
                  <md-icon>comment</md-icon>Product Feedback
                </md-button>
                <md-button
                  v-if="!profile || !profile.years"
                  class="md-info access-button pdf_btn"
                >
                  <template>
                    <md-icon class="ml-5">picture_as_pdf</md-icon>Loading...
                  </template>
                </md-button>
                <md-button
                  v-if="pdfLoading"
                  class="md-info access-button pdf_btn"
                >
                  <template>
                    <md-icon class="ml-5">picture_as_pdf</md-icon>Downloading...
                  </template>
                </md-button>
                <md-button
                  v-if="profile && profile.years && !pdfLoading"
                  target="_blank"
                  class="md-info access-button pdf_btn"
                  @click="generateReport"
                >
                  <md-icon class="ml-5">picture_as_pdf</md-icon>Download PDF
                </md-button>
                <md-button
                  class="md-info access-button csv_btn"
                  @click.native="downloadCSVData"
                  ><md-icon class="ml-5">receipt_long</md-icon>Download CSV
                </md-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 if_card">
        <div class="report_header">
          <ul>
            <li>
              <h6>
                <i class="md-icon">business_center</i>
                <span>Industry:</span>
              </h6>
              <p>{{ this.headerData.industry }}</p>
            </li>
            <li>
              <h6>
                <i class="md-icon">place</i>
                <span>Market Area:</span>
              </h6>
              <p>{{ this.headerData.area }}</p>
            </li>
            <li>
              <h6>
                <i class="md-icon">equalizer</i>
                <span>Sales Class</span>
              </h6>
              <p>{{ this.headerData.sales_class }}</p>
            </li>
          </ul>
          <div class="md-layout">
            <div class="md-layout-item md-size-50">
              <h4>Developed by</h4>
              <ul class="other_info">
                <li>
                  <h6>
                    <i class="md-icon">domain</i>
                    <span>Company Name:</span>
                  </h6>
                  <p>{{ this.user.companyName }}</p>
                </li>
                <li>
                  <h6>
                    <i class="md-icon">panorama</i>
                    <span>Company Logo:</span>
                  </h6>
                  <p>
                    <avatar
                      class="user-avatar"
                      v-if="!user.companyLogo && user.companyName"
                      :size="50"
                      :inline="true"
                      backgroundColor="#b8c3d0"
                      :username="user.companyName"
                      :rounded="false"
                    ></avatar>
                    <img v-if="user.companyLogo" class="logo" :src="user.companyLogo" />
                  </p>
                </li>
              </ul>
            </div>
            <div class="md-layout-item md-size-50">
              <h4>Developed for</h4>
              <ul class="other_info">
                <li>
                  <h6>
                    <i class="md-icon">domain</i>
                    <span>Company Name:</span>
                  </h6>
                  <p>{{ this.headerData.client_name }}</p>
                </li>
                <li>
                  <h6>
                    <i class="md-icon">panorama</i>
                    <span>Company Logo:</span>
                  </h6>
                  <p>
                    <avatar
                      class="user-avatar"
                      v-if="!headerData.client_logo && headerData.client_name"
                      :size="50"
                      :inline="true"
                      backgroundColor="#b8c3d0"
                      :username="headerData.client_name"
                      :rounded="false"
                    ></avatar>
                    <img v-if="headerData.client_logo" class="logo" :src="headerData.client_logo" />
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div> -->
      <modal
        v-if="feedbackModal"
        @close="feedbackModal = false"
        class="feedback_modal"
      >
        <template slot="body">
          <button
            type="button"
            class="close_btn"
            @click="feedbackModal = false"
          >
            <md-icon>clear</md-icon>
          </button>
          <h3 class="modal-title">Have feedback on this product?</h3>
          <p>
            Enter the details below to send your feedback to our Product Team.
          </p>
          <form action class="form_grp">
            <div class="field_wpr">
              <label>Leave A Feedback Note</label>
              <textarea
                v-model="textFeedback"
                placeholder="Type a message"
              ></textarea>
              <md-button @click="sendFeedback" class="md-info md-round mt-4"
                >Send Feedback</md-button
              >
              <div class="md-layout-item">
                <md-checkbox v-model="checkBoxOption1"
                  >1 - Report An Error</md-checkbox
                >
                <md-checkbox v-model="checkBoxOption2" class="pl-3"
                  >2 - Suggest an Improvement</md-checkbox
                >
                <md-checkbox v-model="checkBoxOption3"
                  >3 - Request a Correction</md-checkbox
                >
                <md-checkbox v-model="checkBoxOption4"
                  >4 - Request an Update</md-checkbox
                >
              </div>
            </div>
          </form>
        </template>
      </modal>
    </div>
    <div class="md-layout" v-if="headerData && user">
      <IFRPDF :headerData="headerData" :user="user" ref="html2Pdf" />
    </div>
  </div>
</template>

<script>
import ratingMixin from "@/mixins/rating-mixin";
import formatData from "@/mixins/format-data";
import { mapActions, mapState } from "vuex";
import { Collapse, Modal } from "@/components";
import Avatar from "vue-avatar";
import axios from "axios";
import IFRPDF from "./IFRPDF.vue";

export default {
  components: {
    // Collapse,
    //Avatar,
    Modal,
    IFRPDF,
  },
  mixins: [ratingMixin, formatData],
  props: ["headerData"],
  data() {
    return {
      checkBoxOption1: null,
      checkBoxOption2: null,
      checkBoxOption3: null,
      checkBoxOption4: null,
      category: null,
      feedbackModal: false,
      textFeedback: "",
      filtered_years: [],
      filtered_firms: [],
      filtered_PLDollarIndustry: [],
      filtered_PLPercentIndustry: [],
      filtered_PLDollarFirm: [],
      filtered_PLPercentFirm: [],
      filtered_PLDollarVariance: [],
      filtered_PLPercentVariance: [],
      filtered_BSDollarFirm: [],
      filtered_BSPercentFirm: [],
      filtered_BSDollarIndustry: [],
      filtered_BSPercentIndustry: [],
      filtered_BSDollarVariance: [],
      filtered_BSPercentVariance: [],
      filtered_CFDollarFirm: [],
      filtered_CFDollarIndustry: [],
      filtered_CFDollarVariance: [],
      filtered_PDollarFirm: [],
      filtered_PDollarIndustry: [],
      filtered_PDollarVariance: [],
      filtered_EDollarFirm: [],
      filtered_EDollarIndustry: [],
      filtered_EDollarVariance: [],
      filtered_DRDollarFirm: [],
      filtered_DRDollarIndustry: [],
      filtered_DRDollarVariance: [],
      cashflow: [],
      cashFlowFilteredData: [],
      efficiency: [],
      efficiencyFilteredData: [],
      profitability: [],
      profitabilityFilteredData: [],
      turnover: [],
      debtRiskFilteredData: [],
      changein: [],
      changeinFilteredData: [],
      worksheet: [],
      worksheetFilteredData: [],
      multiplesTableInfo: [
        {
          id: "Low",
          name: "Q1",
        },
        {
          id: "Med",
          name: "Median",
        },
        {
          id: "High",
          name: "Q3",
        },
      ],
    };
  },
  mounted() {
    this.$store.commit("user/SET_PDF_LOADING", false);
    this.parseCSVData();
  },
  computed: {
    ...mapState({
      data: (state) => state.user.report.data,
      parsedData: (state) => {
        let parsed = {};
        state.user.report.data.forEach((e, i) => {
          if (e.year) {
            parsed[e.year] = e;
          }
        });
        return parsed;
      },
      multiplesA: (state) => {
        return state.user.report["multiples_A"]
          ? state.user.report["multiples_A"]
          : [];
      },
      multiplesB: (state) => {
        return state.user.report["multiples_B"]
          ? state.user.report["multiples_B"]
          : [];
      },
      multiplesC: (state) => {
        return state.user.report["multiples_B"]
          ? state.user.report["multiples_B"]
          : [];
      },
      multiplesAll: (state) => {
        return state.user.report["multiples_all"]
          ? state.user.report["multiples_all"]
          : [];
      },
      user: (state) => state.user.user,
      profile: (state) => state.user.report,
      PLtable: (state) => state.user.report.tables.PL,
      BStable: (state) => state.user.report.tables.BS,
      tables: (state) => state.user.report.tables.ratios,
      tablesInfo: (state) => state.user.report.tables["ratioInfo"],
      sourcesUses: (state) => state.user.report["sourcesUses"],
      sourceYears: (state) => state.user.report["sourcesUses"]["years"],
      release_display: (state) => state.user.report.release_display,
      years: (state) => state.user.report.years,
      bznaics_code: (state) => state.user.report.bznaics,
      sector_name: (state) => state.user.report.data[0].sector,
      pdfLoading: (state) => state.user.pdfLoading,
    }),
    sourceTablesInfo() {
      return _.omit(this.sourcesUses, "years");
    },
    filteredProfile() {
      return Object.values(this.profile.data).filter((item) => item);
    },
    filteredData() {
      return Object.values(this.data).filter((item) => item);
    },
    actualData() {
      return this.filteredData[0]["cashflow"];
    },
    pdfDownloadSetting() {
      return this.user &&
        this.user.preferences &&
        this.user.preferences.defaultPDFDownload
        ? this.user.preferences.defaultPDFDownload
        : "_blank";
    },
  },
  watch: {
    profile() {
      this.parseCSVData();
    },
    checkBoxOption1(newVal, oldVal) {
      if (newVal) {
        this.checkBoxOption2 = false;
        this.checkBoxOption3 = false;
        this.checkBoxOption4 = false;
        this.category = "1";
      }
    },
    checkBoxOption2(newVal, oldVal) {
      if (newVal) {
        this.checkBoxOption1 = false;
        this.checkBoxOption3 = false;
        this.checkBoxOption4 = false;
        this.category = "2";
      }
    },
    checkBoxOption3(newVal, oldVal) {
      if (newVal) {
        this.checkBoxOption1 = false;
        this.checkBoxOption2 = false;
        this.checkBoxOption4 = false;
        this.category = "3";
      }
    },
    checkBoxOption4(newVal, oldVal) {
      if (newVal) {
        this.checkBoxOption1 = false;
        this.checkBoxOption2 = false;
        this.checkBoxOption3 = false;
        this.category = "4";
      }
    },
  },
  methods: {
    ...mapActions({
      registerProductExport: "tracking/registerProductExport",
    }),
    generateReport() {
      this.$refs.html2Pdf.generateReport();
      this.registerProductExport({
        userId: this.user?.userID,
        productId: this.$route.params.id,
        exportType: "PDF",
      });
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          if (!this.$store.getters["user/pdfMustBeDownloaded"])
            window.open(pdf.output("bloburl"), "_blank");
        });
    },
    feedback() {
      this.feedbackModal = true;
    },
    sendFeedback() {
      if (this.category) {
        let currentSession = localStorage.getItem(
          "vue-authenticate.vueauth_access_token"
        );
        axios
          .post(
            process.env.VUE_APP_API_BASE_URL + "/user/feedback/submit",
            {},
            {
              params: {
                session_id: currentSession,
                feedback: this.textFeedback,
                url: `${window.location.href}`,
                category: this.category,
              },
            }
          )
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                "SET_ERROR_INFO",
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/feedback/submit" <br>`
              );
              throw new Error(
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
              );
            }

            if (res.data.success)
              this.$store.dispatch("alerts/success", "Data saved.");
            else
              this.$store.dispatch(
                "alerts/error",
                "An error occured. please try again"
              );

            this.feedbackModal = false;
            this.textFeedback = null;
            this.category = null;

            this.checkBoxOption1 = false;
            this.checkBoxOption2 = false;
            this.checkBoxOption3 = false;
            this.checkBoxOption4 = false;
          });
      } else {
        this.$store.commit("SET_ERROR_BIT", true);
        this.$store.commit(
          "SET_ERROR_INFO",
          "<br>" +
            "Server responded with error = True <br> errorCode: " +
            "category_not_set" +
            `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/feedback/submit" <br>`
        );
      }
    },

    parseCSVData() {
      if (!this.profile || !this.profile.years) {
        return;
      }
      if (this.profile && this.profile.years) {
        this.profile.years.forEach((e, i) => {
          this.filtered_years.push(e);
        });
      }
      if (this.profile.data) {
        let firmData = Object.values(this.profile.data)
          .filter((item) => item)
          .map((item) => ({ ...item, firms: item.firms }));

        firmData.forEach((element) => {
          if (element.firms)
            this.filtered_firms.push(parseFloat(element.firms));
        });
      }
      if (
        this.headerData.sales_class &&
        this.headerData.sales_class.includes(",")
      ) {
        this.sales_class_csv = this.headerData.sales_class.replace(/,/g, "");
      } else this.sales_class_csv = this.headerData.sales_class;

      let PLdollarFirm = this.formatTable(this.PLtable, "firm", "dollar");
      let PLpercentFirm = this.formatTable(this.PLtable, "firm", "percent");
      let PLdollarIndustry = this.formatTable(
        this.PLtable,
        "industry",
        "dollar"
      );
      let PLpercentIndustry = this.formatTable(
        this.PLtable,
        "industry",
        "percent"
      );

      let PLdollarVariance = this.formatTable(
        this.PLtable,
        "variance",
        "dollar"
      );
      let PLpercentVariance = this.formatTable(
        this.PLtable,
        "variance",
        "percent"
      );

      PLdollarIndustry.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_PLDollarIndustry.push(v);
      });
      PLpercentIndustry.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_PLPercentIndustry.push(v);
      });
      PLdollarFirm.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_PLDollarFirm.push(v);
      });
      PLpercentFirm.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_PLPercentFirm.push(v);
      });
      PLpercentVariance.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_PLPercentVariance.push(v);
      });
      PLdollarVariance.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_PLDollarVariance.push(v);
      });

      // ----------------------------- BS -----------------------------------

      let BSdollarFirm = this.formatTable(this.BStable, "firm", "dollar");
      let BSpercentFirm = this.formatTable(this.BStable, "firm", "percent");
      let BSdollarIndustry = this.formatTable(
        this.BStable,
        "industry",
        "dollar"
      );
      let BSpercentIndustry = this.formatTable(
        this.BStable,
        "industry",
        "percent"
      );
      let BSdollarVariance = this.formatTable(
        this.BStable,
        "variance",
        "dollar"
      );
      let BSpercentVariance = this.formatTable(
        this.BStable,
        "variance",
        "percent"
      );

      BSdollarFirm.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_BSDollarFirm.push(v);
      });
      BSpercentFirm.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_BSPercentFirm.push(v);
      });

      BSdollarIndustry.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_BSDollarIndustry.push(v);
      });
      BSpercentIndustry.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_BSPercentIndustry.push(v);
      });

      BSdollarVariance.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_BSDollarVariance.push(v);
      });
      BSpercentVariance.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_BSPercentVariance.push(v);
      });

      // ----------------------- Cash Flow --------------------------------

      let CFtable = {
        "Accounts Payable: Business Revenue": this.tables.cashflow
          .accounts_payable_business_revenue,
        "Current Ratio": this.tables.cashflow.current_ratio,
        "Quick Ratio": this.tables.cashflow.quick_ratio,
        "Days Payable": this.tables.cashflow.days_payable,
        "Current Liabilities: Inventory": this.tables.cashflow.current_liabilities_inventory,
        "Net Working Capital: Business Revenue": this.tables.cashflow.net_working_capital,
        "Cost of Sales: Accounts Payable": this.tables.cashflow.cosPayables,
        "Cost of Sales: Inventory": this.tables.cashflow.cosInventory,
      };

      let CFdollarFirm = this.formatTable(CFtable, "firm");
      let CFdollarIndustry = this.formatTable(CFtable, "industry");
      let CFdollarVariance = this.formatTable(CFtable, "variance");

      CFdollarFirm.forEach(async (element) => {
        if (!element || !element.dates) {
          this.filtered_CFDollarFirm.push({});
          return;
        }
        if (element.name?.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element?.dates);
        let v = [];
        await k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_CFDollarFirm.push(v);
      });
      CFdollarIndustry.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_CFDollarIndustry.push(v);
      });
      CFdollarVariance.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_CFDollarVariance.push(v);
      });

      // -------------------------- Profitability ----------------------

      let Ptable = {
        "EBITDA: Business Revenue (%)": this.tables["profitability"]
          .ebitda_business_revenue,
        "Pre-Tax Return On Assets (%)": this.tables["profitability"]
          .return_on_assets,
        "Pre-Tax Return on Net Worth (%)": this.tables["profitability"]
          .return_on_net_worth,
        "Pre-Tax Return on Business Revenue (%)": this.tables["profitability"]
          .return_on_business_revenue,
        "Discretionary Owner Earnings": this.tables["profitability"]
          .discretionary_owner_earnings,
        "After-Tax Return On Assets (%)": this.tables["profitability"]
          .return_on_assets_after_tax,
        "After-Tax Return On Net Worth (%)": this.tables["profitability"]
          .return_on_net_worth_after_tax,
        "After-Tax Return On Business Revenue (%)": this.tables["profitability"]
          .return_on_business_revenue_after_tax,
        "Profit/Employee": this.tables["profitability"].profit_employee,
        "Owner Earnings/Employee": this.tables["profitability"]
          .owner_earnings_employee,
      };

      let PdollarFirm = this.formatTable(Ptable, "firm");
      let PdollarIndustry = this.formatTable(Ptable, "industry");
      let PdollarVariance = this.formatTable(Ptable, "variance");

      PdollarFirm.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_PDollarFirm.push(v);
      });
      PdollarIndustry.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_PDollarIndustry.push(v);
      });
      PdollarVariance.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_PDollarVariance.push(v);
      });

      // -------------------------- Efficiency ----------------------

      let Etable = {
        "Assets: Business Revenue": this.tables["efficiency"]
          .assets_business_revenue,
        "Days Inventory": this.tables["efficiency"].days_inventory,
        "Days Receivables": this.tables["efficiency"].days_receivables,
        "Current Asset Turnover": this.tables["efficiency"]
          .current_asset_turnover,
        "Fixed Asset Turnover (Business Revenue/Fixed Assets)": this.tables[
          "efficiency"
        ].fixed_asset_turnover,
        "Gross Margin: Business Revenue": this.tables["efficiency"]
          .gross_margin_business_revenue,
        "Sales Per Employee": this.tables["efficiency"].sales_per_employee,
        "Inventory Turnover": this.tables["efficiency"].invTurnover,
        "Receivables Turnover": this.tables["efficiency"].arTurnover,
        "Total Asset Turnover": this.tables["efficiency"].totalAssetTurnover,
        "Working Capital Turnover": this.tables["efficiency"]
          .workingCapitalTurnover,
        "Days Working Capital": this.tables["efficiency"].daysWorkingCapital,
        "Cash Turnover": this.tables["efficiency"].cashTurnover,
        "Efficiency Index": this.tables["efficiency"].efficiency_index,
      };

      let EdollarFirm = this.formatTable(Etable, "firm");
      let EdollarIndustry = this.formatTable(Etable, "industry");
      let EdollarVariance = this.formatTable(Etable, "variance");

      EdollarFirm.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_EDollarFirm.push(v);
      });
      EdollarIndustry.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_EDollarIndustry.push(v);
      });
      EdollarVariance.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_EDollarVariance.push(v);
      });

      // ------------------------- Debt Risk ------------------------------

      let DRtable = {
        "Interest Coverage": this.tables["turnover"].interest_coverage,
        "Current Liabilities: Net Worth": this.tables["turnover"]
          .current_liabilities_net_worth,
        "Long-Term Liabilities: Net Worth": this.tables["turnover"]
          .long_term_liabilities_net_worth,
        "Loans-Notes Payable/Net Worth": this.tables["turnover"]
          .loans_notes_payable_net_worth,
        "Modified Z-Score": this.tables["turnover"].zscore,
        "Total Liabilities: Net Worth": this.tables["turnover"]
          .total_liabilities_net_worth,
        "Fixed Assets: Net Worth": this.tables["turnover"].fixedAssetsNetWorth,
      };

      let DRdollarFirm = this.formatTable(DRtable, "firm");
      let DRdollarIndustry = this.formatTable(DRtable, "industry");
      let DRdollarVariance = this.formatTable(DRtable, "variance");

      DRdollarFirm.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_DRDollarFirm.push(v);
      });
      DRdollarIndustry.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_DRDollarIndustry.push(v);
      });
      DRdollarVariance.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_DRDollarVariance.push(v);
      });

      Object.entries(this.sourceTablesInfo).forEach(([table, data]) => {
        this.$set(this, table, this.formatSourcesData(table, data));
      });

      this.changein.forEach((element, index) => {
        let k = [];
        if (element.dates) {
          Object.values(element.dates).forEach((e, index) => {
            k.push(e);
          });
        }
        k.unshift(element.title);
        this.changeinFilteredData.push(k);
      });
      this.worksheet.forEach((element, index) => {
        let k = [];
        if (element.dates) {
          Object.values(element.dates).forEach((e, index) => {
            k.push(e);
          });
        }
        k.unshift(element.title);
        this.worksheetFilteredData.push(k);
      });
    },
    formatSourcesData(table, data) {
      let getDates = (id) =>
        this.sourceYears.reduce((acc, cur, index) => {
          let value = this.actualData[this.sourceYears.length - index - 1][id];

          value = isNaN(Number(value)) ? value : Number(value.toFixed(0));

          return { ...acc, [cur]: value };
        }, {});

      return data.map((item) => ({
        ...item,
        dates: getDates(item.id),
      }));
    },
    async downloadCSVData() {
      let csv = "";
      let csvData = await this.getCsvData();

      csvData.forEach((row) => {
        csv += row.join(",");
        csv += "\n";
      });
      const anchor = document.createElement("a");
      anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
      anchor.target = "_blank";
      anchor.download = "Industry Financial Report.csv";
      anchor.click();
      this.registerProductExport({
        userId: this.user?.userID,
        productId: this.$route.params.id,
        exportType: "CSV",
      });
    },
    async getCsvData() {
      let csvData = [
        ["Industry Financial Report"],
        ['"Release Date"', this.release_display],
        [""],
        ["Segment", "Industry"],
        [""],
        [this.industry_title],
        ["[" + parseInt(this.bznaics_code) + "]" + " Sector", this.sector_name],
        ["Market", this.headerData.area],
        ["Sales Class", this.sales_class_csv],
        [""],
      ];
      csvData.push(["Firms Analyzed", this.filtered_years]);
      csvData.push(["", this.filtered_firms]);
      csvData.push([""]);

      let year_places = [];
      this.profile.years.forEach((e, i) => {
        year_places.push("");
      });

      csvData.push([
        "Income and Expense - Profit and Loss($)",
        year_places,
        "",
        this.sector_name,
        year_places,
        "Variance",
      ]);
      csvData.push([
        "",
        this.filtered_years,
        "",
        this.filtered_years,
        "",
        this.filtered_years,
      ]);

      this.filtered_PLDollarFirm.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        e.push("");

        // Remove label
        this.filtered_PLDollarIndustry[i].shift();
        e = e.concat(this.filtered_PLDollarIndustry[i]);

        e.push("");
        // Remove label
        this.filtered_PLDollarVariance[i].shift();
        e = e.concat(this.filtered_PLDollarVariance[i]);
        csvData.push(e);
      });

      csvData.push([""]);

      csvData.push([
        "Income and Expense - Profit and Loss(%)",
        year_places,
        "",
        this.sector_name,
        year_places,
        "Variance",
      ]);
      csvData.push([
        "",
        this.filtered_years,
        "",
        this.filtered_years,
        "",
        this.filtered_years,
      ]);

      this.filtered_PLPercentFirm.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        e.push("");

        // Remove label
        this.filtered_PLPercentIndustry[i].shift();
        e = e.concat(this.filtered_PLPercentIndustry[i]);

        e.push("");
        // Remove label
        this.filtered_PLPercentVariance[i].shift();
        e = e.concat(this.filtered_PLPercentVariance[i]);
        csvData.push(e);
      });

      csvData.push([""]);

      csvData.push([
        "Balance Sheet ($)",
        year_places,
        "",
        this.sector_name,
        year_places,
        "Variance",
      ]);
      csvData.push([
        "",
        this.filtered_years,
        "",
        this.filtered_years,
        "",
        this.filtered_years,
      ]);

      this.filtered_BSDollarFirm.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        e.push("");

        // Remove label
        this.filtered_BSDollarIndustry[i].shift();
        e = e.concat(this.filtered_BSDollarIndustry[i]);

        e.push("");
        // Remove label
        this.filtered_BSDollarVariance[i].shift();
        e = e.concat(this.filtered_BSDollarVariance[i]);
        csvData.push(e);

        if (Array.isArray(e) && e[0] === "Total Assets") {
          csvData.push(["Liabilities"]);
        }
      });

      csvData.push([""]);

      csvData.push([
        "Balance Sheet (%)",
        year_places,
        "",
        this.sector_name,
        year_places,
        "Variance",
      ]);
      csvData.push([
        "",
        this.filtered_years,
        "",
        this.filtered_years,
        "",
        this.filtered_years,
      ]);

      this.filtered_BSPercentFirm.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        e.push("");

        // Remove label
        this.filtered_BSPercentIndustry[i].shift();
        e = e.concat(this.filtered_BSPercentIndustry[i]);

        e.push("");
        // Remove label
        this.filtered_BSPercentVariance[i].shift();
        e = e.concat(this.filtered_BSPercentVariance[i]);
        csvData.push(e);

        if (Array.isArray(e) && e[0] === "Total Assets") {
          csvData.push(["Liabilities"]);
        }
      });

      csvData.push([""]);
      csvData.push([
        "Financial Ratios: Cash Flow-Solvency",
        year_places,
        "",
        this.sector_name,
        year_places,
        "Variance",
      ]);
      csvData.push([
        "",
        this.filtered_years,
        "",
        this.filtered_years,
        "",
        this.filtered_years,
      ]);

      this.filtered_CFDollarFirm.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        e.push("");

        // Remove label
        this.filtered_CFDollarIndustry[i].shift();
        e = e.concat(this.filtered_CFDollarIndustry[i]);

        e.push("");
        // Remove label
        this.filtered_CFDollarVariance[i].shift();
        e = e.concat(this.filtered_CFDollarVariance[i]);
        csvData.push(e);
      });

      csvData.push([""]);
      csvData.push([""]);
      csvData.push([""]);

      csvData.push([
        "Financial Ratios: Profitability",
        year_places,
        "",
        this.sector_name,
        year_places,
        "Variance",
      ]);
      csvData.push([
        "",
        this.filtered_years,
        "",
        this.filtered_years,
        "",
        this.filtered_years,
      ]);

      this.filtered_PDollarFirm.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        e.push("");

        // Remove label
        this.filtered_PDollarIndustry[i].shift();
        e = e.concat(this.filtered_PDollarIndustry[i]);

        e.push("");
        // Remove label
        this.filtered_PDollarVariance[i].shift();
        e = e.concat(this.filtered_PDollarVariance[i]);
        csvData.push(e);
      });

      csvData.push([""]);
      csvData.push([""]);
      csvData.push([""]);

      csvData.push([
        "Financial Ratios: Efficiency",
        year_places,
        "",
        this.sector_name,
        year_places,
        "Variance",
      ]);
      csvData.push([
        "",
        this.filtered_years,
        "",
        this.filtered_years,
        "",
        this.filtered_years,
      ]);

      this.filtered_EDollarFirm.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        e.push("");

        // Remove label
        this.filtered_EDollarIndustry[i].shift();
        e = e.concat(this.filtered_EDollarIndustry[i]);

        e.push("");
        // Remove label
        this.filtered_EDollarVariance[i].shift();
        e = e.concat(this.filtered_EDollarVariance[i]);
        csvData.push(e);
      });

      csvData.push([""]);
      csvData.push([""]);
      csvData.push([""]);

      csvData.push([
        "Financial Ratios: Debt-Risk",
        year_places,
        "",
        this.sector_name,
        year_places,
        "Variance",
      ]);
      csvData.push([
        "",
        this.filtered_years,
        "",
        this.filtered_years,
        "",
        this.filtered_years,
      ]);

      this.filtered_DRDollarFirm.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        e.push("");

        // Remove label
        this.filtered_DRDollarIndustry[i].shift();
        e = e.concat(this.filtered_DRDollarIndustry[i]);

        e.push("");
        // Remove label
        this.filtered_DRDollarVariance[i].shift();
        e = e.concat(this.filtered_DRDollarVariance[i]);
        csvData.push(e);
      });

      csvData.push([""]);
      csvData.push([""]);
      csvData.push([""]);
      csvData.push(["Sources & Uses of Funds"]);
      csvData.push(["", this.sourceYears]);

      this.changeinFilteredData.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push(["Worksheet:"]);
      this.worksheetFilteredData.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });

      // ------------------- Valuation -------------------------
      csvData.push([""]);
      csvData.push([""]);
      csvData.push([""]);
      csvData.push(["Valuation Multiples"]);
      csvData.push(["Sales Group: < $2.5m:"]);
      csvData.push(["", "Sales Multiples", "Earnings Multiples"]);

      this.multiplesTableInfo.forEach((item, index) => {
        csvData.push([
          item.name,
          this.multiplesA[`Sales${item.id}`],
          this.multiplesA[`Earnings${item.id}`],
        ]);
      });

      csvData.push([""]);

      csvData.push(["Sales Group: $2.5m - $24.9m:"]);
      csvData.push(["", "Sales Multiples", "Earnings Multiples"]);

      this.multiplesTableInfo.forEach((item, index) => {
        csvData.push([
          item.name,
          this.multiplesB[`Sales${item.id}`],
          this.multiplesB[`Earnings${item.id}`],
        ]);
      });

      csvData.push([""]);

      csvData.push(["Sales Group: > $25m:"]);
      csvData.push(["", "Sales Multiples", "Earnings Multiples"]);

      this.multiplesTableInfo.forEach((item, index) => {
        csvData.push([
          item.name,
          this.multiplesC[`Sales${item.id}`],
          this.multiplesC[`Earnings${item.id}`],
        ]);
      });

      csvData.push([""]);

      csvData.push(["Sales Group: All:"]);
      csvData.push(["", "Sales Multiples", "Earnings Multiples"]);

      this.multiplesTableInfo.forEach((item, index) => {
        csvData.push([
          item.name,
          this.multiplesAll[`Sales${item.id}`],
          this.multiplesAll[`Earnings${item.id}`],
        ]);
      });

      return csvData;
    },
  },
};
</script>
<style lang="scss"></style>
